module.exports = __webpack_public_path__ + "img/pic_fast_food_S.19bd5605.jpg";